// 主题颜色配置 - 统一管理
export const themeColors = {
  // 主文字色
  'theme-text': {
    light: '#333333',
    dark: '#e5e5e5',
  },
  'warning': {
    light: '#FAAD3A',
    dark: '#FAAD3A',
  },
  'warning-hover': {
    light: '#FAAD3AE6',
    dark: '#FAAD3AE6',
  },
  'danger': {
    light: '#FF5555',
    dark: '#FF5555',
  },
  'f4and33': {
    light: '#F4F4F4',
    dark: '#333333',
  },
  'EBand33': {
    light: '#EBEBEB',
    dark: '#333333',
  },
  'ccc': {
    light: '#cccccc',
    dark: '#cccccc',
  },
  '51Aand2649EF': {
    light: '#16151A',
    dark: '#2649EF',
  },
  '51AandWhite': {
    light: '#16151A',
    dark: '#ffffff',
  },
  'whiteAnd51A': {
    light: '#ffffff',
    dark: '#16151A',
  },
  'eb': {
    light: '#EBEBEB',
    dark: '#EBEBEB',
  },
  '9b': {
    light: '#9B9B9B',
    dark: '#9B9B9B',
  },
  'vip-progress-rate-tag-mid': {
    light: '#BABDBD',
    dark: '#BABDBD',
  },
  'vip-progress-rate-tag-end': {
    light: '#848686',
    dark: '#848686',
  },
  'primary': {
    light: '#2649EF',
    dark: '#2649EF',
  },
  'while': {
    light: '#ffffff',
    dark: '#ffffff',
  },
  'white': {
    light: '#ffffff',
    dark: '#ffffff',
  },
  'whiteAndCcc': {
    light: '#ffffff',
    dark: '#cccccc',
  },
  '16151A': {
    light: '#16151A',
    dark: '#16151A',
  },
  'f4and16151A': {
    light: '#F4F4F4',
    dark: '#16151A',
  },
  'f9': {
    light: '#F9F9F9',
    dark: '#F9F9F9',
  },
  // ECO 活动页面颜色
  'eco-rise': {
    light: '#01BD8B',
    dark: '#01BD8B',
  },
  'eco-rise-10': {
    light: '#01BD8B1A',
    dark: '#01BD8B1A',
  },
  'danger-10': {
    light: '#FF55551A',
    dark: '#FF55551A',
  },
  'trade-red': {
    light: '#FF5555',
    dark: '#FF5555',
  },
  'trade-red-10': {
    light: '#FF55551A',
    dark: '#FF55551A',
  },
  'f4': {
    light: '#F4F4F4',
    dark: '#F4F4F4',
  },
  'cccand9b': {
    light: '#cccccc',
    dark: '#9b9b9b',
  },
  'cccand9b80': {
    light: '#cccccc',
    dark: '#9b9b9b80',
  },
  'f4andcc': {
    light: '#F4F4F4',
    dark: '#cccccc',
  },
  'f9and3305': {
    light: '#F9F9F9',
    dark: '#33333380',
  },
  'f9and2c': {
    light: '#F9F9F9',
    dark: '#2C2C2C',
  },
  'f4and2c': {
    light: '#F4F4F4',
    dark: '#2C2C2C',
  },
  'eband2c': {
    light: '#EBEBEB',
    dark: '#2C2C2C',
  },
  '2C344E': {
    light: '#2C344E',
    dark: '#2C344E',
  },
  'whiteAnd2c': {
    light: '#ffffff',
    dark: '#2C2C2C',
  },
  '2C2C2C': {
    light: '#2C2C2C',
    dark: '#2C2C2C',
  },
  '9bAnd16151A': {
    light: '#9B9B9B',
    dark: '#16151A',
  },
  'whiteAnd21': {
    light: '#ffffff',
    dark: '#212121',
  },
  'f4and2C2C2C80': {
    light: '#F4F4F4',
    dark: '#2C2C2C80',
  },
  'ebandWhite': {
    light: '#EBEBEB',
    dark: '#ffffff',
  },
  'eband9B9B9B33': {
    light: '#EBEBEB',
    dark: '#9B9B9B33',
  },
  '9bAnd9b80': {
    light: '#9b9b9b',
    dark: '#9b9b9b80',
  },
  'ebAnd21': {
    light: '#EBEBEB',
    dark: '#212121',
  },
  '333': {
    light: '#333333',
    dark: '#333333',
  },
  '2C2C2C80': { // 50透明度
    light: '#2C2C2C80',
    dark: '#2C2C2C80',
  },
  '212121': {
    light: '#212121',
    dark: '#212121',
  },
  '21212180': {
    light: '#21212180',
    dark: '#21212180',
  },
  '21212199': {
    light: '#21212199',
    dark: '#21212199',
  },
  '11121B': {
    light: '#11121B',
    dark: '#11121B',
  },
  '06F0C6': {
    light: '#06F0C6',
    dark: '#06F0C6',
  },
  '06F0C6E6': {
    light: '#06F0C6E6',
    dark: '#06F0C6E6',
  },
  '06F0C61A': {
    light: '#06F0C61A',
    dark: '#06F0C61A',
  },
  '06F0C60A': {
    light: '#06F0C60A',
    dark: '#06F0C60A',
  },
  '06F0C666': {
    light: '#06F0C666',
    dark: '#06F0C666',
  },
  '06F0C699': {
    light: '#06F0C699',
    dark: '#06F0C699',
  },
  'F07B41': {
    light: '#F07B41',
    dark: '#F07B41',
  },
  'D8FF06': {
    light: '#D8FF06',
    dark: '#D8FF06',
  },
  'E212D8': {
    light: '#E212D8',
    dark: '#E212D8',
  },
  '1F4AFF': {
    light: '#1F4AFF',
    dark: '#1F4AFF',
  },
  '9B9B9B33': {
    light: '#9B9B9B33',
    dark: '#9B9B9B33',
  },
  '72737A80': {
    light: '#72737A80',
    dark: '#72737A80',
  },
  'FFFFFF0A': {
    light: '#FFFFFF0A',
    dark: '#FFFFFF0A',
  },
  'FFFFFF0F': {
    light: '#FFFFFF0F',
    dark: '#FFFFFF0F',
  },
  '0B0B0B': {
    light: '#0B0B0B',
    dark: '#0B0B0B',
  },
  'f4and9B9B9B33': {
    light: '#F4F4F4',
    dark: '#9B9B9B33',
  },
  '000': {
    light: '#000000',
    dark: '#000000',
  },
  'world-cup-gold': {
    light: '#FEE5B3',
    dark: '#FEE5B3',
  },
  'world-cup-countdown': {
    light: '#9B9B9B40',
    dark: '#9B9B9B40',
  },
  'world-cup-brand': {
    light: '#3E5CF1',
    dark: '#3E5CF1',
  },
  'world-cup-card': {
    light: '#2C2C2C80',
    dark: '#2C2C2C80',
  },
  'world-cup-line': {
    light: '#2C2C2C',
    dark: '#2C2C2C',
  },
  'world-cup-bg': {
    light: '#000C0E',
    dark: '#000C0E',
  },
  'world-cup-white-transparent': {
    light: '#FFFFFF00',
    dark: '#FFFFFF00',
  },
  'world-cup-card-border': {
    light: '#1F4AFF',
    dark: '#1F4AFF',
  },
  'world-cup-card-gradient-start': {
    light: '#1A3495',
    dark: '#1A3495',
  },
  'world-cup-card-gradient-end': {
    light: '#0F1C57',
    dark: '#0F1C57',
  },
  'world-cup-dark-label': {
    light: '#2C2C2C',
    dark: '#2C2C2C',
  },
  'world-cup-flag-bg': {
    light: '#D9D9D9',
    dark: '#D9D9D9',
  },
  'world-cup-silver': {
    light: '#B0B0B0',
    dark: '#B0B0B0',
  },
  'world-cup-bronze': {
    light: '#C4A895',
    dark: '#C4A895',
  },
  'world-cup-prize-gold-bg': {
    light: '#FEE5B31A',
    dark: '#FEE5B31A',
  },
  'world-cup-prize-gold-border': {
    light: '#FEE5B380',
    dark: '#FEE5B380',
  },
  'world-cup-prize-silver-bg': {
    light: '#CBCBCB1A',
    dark: '#CBCBCB1A',
  },
  'world-cup-prize-silver-border': {
    light: '#CBCBCB80',
    dark: '#CBCBCB80',
  },
  'world-cup-prize-bronze-bg': {
    light: '#907A5C1A',
    dark: '#907A5C1A',
  },
  'world-cup-prize-bronze-border': {
    light: '#907A5C80',
    dark: '#907A5C80',
  },
  'world-cup-progress-track': {
    light: '#9B9B9B33',
    dark: '#9B9B9B33',
  },
  'world-cup-warning-bg': {
    light: '#FAAD3A1A',
    dark: '#FAAD3A1A',
  },
  'world-cup-rank-gold-from': {
    light: '#98896B00',
    dark: '#98896B00',
  },
  'world-cup-rank-gold-to': {
    light: '#FEE5B31A',
    dark: '#FEE5B31A',
  },
  'world-cup-rank-silver-from': {
    light: '#65656500',
    dark: '#65656500',
  },
  'world-cup-rank-silver-to': {
    light: '#CBCBCB1A',
    dark: '#CBCBCB1A',
  },
  'world-cup-rank-bronze-from': {
    light: '#2A241B00',
    dark: '#2A241B00',
  },
  'world-cup-rank-bronze-to': {
    light: '#907A5C1A',
    dark: '#907A5C1A',
  },
  'F13EDF': {
    light: '#F13EDF',
    dark: '#F13EDF',
  },
  // 可以继续添加更多颜色...
}
